import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import Shipment from './Shipment'
import Results from './Results/Results'
import Settlement from './Settlement'
import ClaimDetails from './Claim'
import _ from 'lodash'
import loading from '../../media/loading.svg'
import { filter } from 'rxjs/operators'

const Claim = (props) => {
  const showClaimDetails = props.shipment
  const view = props.shipment === 'loading' ? 'loading' : !_.isNil(props.shipment) ? 'shipment' : 'wizard'
    const disabled = _.isNil(props.shipment?.id)
  const disabledStyle = disabled ? {pointerEvents: 'none'} : {}
  const disabledClass = disabled ? ' o-50 ' : ''
  return (
    <div className='w-100 flex overflow-y-auto' style={{maxHeight: props.ui?.window?.height - props.ui?.window?.header - 5}}>
      <div className='ph3' style={{flexGrow: 1}}>
        <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' style={{position: 'sticky', top:0, zIndex: 100}}>
          <div className='flex items-center'>
            <FontAwesomeIcon className='f6 white' icon={faTruck} />
            <div className='pl2 fw7 f6 white'>Shipment </div>
            { props.shipment?.id && <div className='pl2 yellow fw6 f5' style={{fontFamily: 'monospace'}}> @{props.shipment?.companyUuid}</div> }
            {/* { <div className='relative pl4 fw6 f7 white' style={{top:1}}> Duplicate </div> } */}
          </div>
          <div className='flex'>
            {props.company?.id === 3 && (
              <div className='flex'>
                <div className='ml2 pa2 ph3 br2 white bg-evonik-light-purple f6 pointer'
                  onClick={e => Dispatch.nextAction('__.Modal.open', {type: 'simpleScan'})}
                >Scan</div>
                <div className='ml2 pa2 ph3 br2 white bg-evonik-light-purple f6 pointer'
                  onClick={e => Dispatch.nextAction('__.Modal.open', {type: 'attach'})}
                >Attach</div>
              </div>
            )}
            <div className={'ml2 pa2 ph3 br2 white bg-evonik-light-purple f6 pointer ' + disabledClass}
              onClick={e => Dispatch.nextAction('shipment.duplicate')}
              style={{...disabledStyle}}
            >Duplicate</div>
            <SubmitButton id={'save'} className='' 
              responseId='save'
              defaultChild={ props => (
                <div className='ml2 pa2 ph3 br2 white bg-evonik-light-purple f6 pointer'
                  onClick={e => Dispatch.nextAction('shipment.save')}
                >Save</div>
              )}
              loadingChild={ props => (
                  <div className='mh3 ' style={{width:28}}>
                    <img src={loading} alt='loading'/>
                  </div>
              )}
              errorChild={ props => (
                <div className='pl3 f7 fw4 red tr pointer'>Error</div>
              )}
              loadingStream={
                Dispatch.getAction('Request.shipment')
                }
              successStream={
                Dispatch.getAction('Response.shipment')
                  .pipe(
                    filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.shipment) ))),
                  )
                }
              errorStream={
                Dispatch.getAction('Response.shipment')
                  .pipe(
                    filter(e => !_.isNil(e.errors)),
                  )}
            />
          </div>
        </div>
        {view === 'loading' ?
          <div className='h5 w-100 flex justify-center'>
            <img className='w4' src={loading} alt='loading'></img>
          </div>
          :
          <div key={props.shipment?.key}>
            <Shipment {...props}/>
            { showClaimDetails &&
              <>
                <ClaimDetails {...props} />
                <div className='pt2'>
                  <Results {...props}/>
                </div>
              </>
            }
          </div>
        }
        </div>
        {view !== 'loading' &&
          showClaimDetails &&
            <Settlement key={props.shipment?.key} {...props}/>
        }
    </div>
  )
}

export default Claim